import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ManageCohortList = lazy(() => import("../components/ManageCohortList"));

const cohortListRoutes: RouteObject = {
  path: "cohorts",
  element: <ManageCohortList />,
};

export default cohortListRoutes;
